import React from "react";

function Landing(props) {
  return (
    <iframe
      width="100%"
      height="100%"
      frameborder="0"
      id="page"
      src="https://thesmartglove.landen.co/"
    ></iframe>
  );
}

export default Landing;
